import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const FILL = color.border.ctaSecondary;

const body: _SVGIcon.IconBody = (params) => {
	const fill = params?.fill ?? FILL;
	return `<path d="M11.9383 6L12.0617 6L17 10.2426L17 12.0936L12.6276 8.37088L12.6276 18L11.3724 18L11.3724 8.37088L7 12.0936L7 10.2426L11.9383 6Z" fill="${fill}"/>`;
};

export default {
	W: 24,
	H: 24,
	body,
} as _SVGIcon.Icon;
